function ConfirmPublishCampaignModalController($scope, $uibModalInstance, LocalisationService, campaign) {

    var self = this;

    /**
     * Initialises the component
     */
    self.initialise = function() {
        $scope.campaign = campaign;
        $scope.campaign.LaunchDate = LocalisationService.formatDateLong($scope.campaign.LaunchDate);
    };

    /**
     * Close the modal and return true to the caller
     */
    $scope.Confirm = function () {
        $uibModalInstance.close(true);
    };

    /**
     * Close the modal and return false to the caller
     */
    $scope.Cancel = function () {
        $uibModalInstance.close(false);
    };

    self.initialise();
}

angular
    .module('dashboard')
    .controller('ConfirmPublishCampaignModalController', ['$scope', '$uibModalInstance', 'LocalisationService', 'campaign', ConfirmPublishCampaignModalController]);